import { render, staticRenderFns } from "./article-binder.vue?vue&type=template&id=772b5cb6&scoped=true&"
import script from "./article-binder.vue?vue&type=script&lang=js&"
export * from "./article-binder.vue?vue&type=script&lang=js&"
import style0 from "./article-binder.vue?vue&type=style&index=0&id=772b5cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b5cb6",
  null
  
)

export default component.exports